import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { EnvironmentProvider, useEnvironment } from './context/EnvironmentContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import ArztPage from './pages/ArztPage';
import PraxisPage from './pages/PraxisPage';
import ZuweisungPage from './pages/ZuweisungPage';
import KalenderPage from './pages/KalenderPage';
import UsersPage from './pages/UsersPage';
import LoginPage from './pages/LoginPage';
import EnvironmentSelectionPage from './pages/EnvironmentSelectionPage';
import PDFSchedulePage from './pages/PDFSchedulePage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import OfflineIndicator from './components/common/OfflineIndicator';

// Component to handle app context checks
const AppRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentApp } = useEnvironment();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated && !currentApp) {
    return <Navigate to="/select-app" replace />;
  }

  return <>{children}</>;
};

const AppContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/select-app"
        element={
          <ProtectedRoute>
            <EnvironmentSelectionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sched-pdf"
        element={<PDFSchedulePage />}
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/aerzte" element={<ArztPage />} />
                  <Route path="/praxen" element={<PraxisPage />} />
                  <Route path="/zuweisungen" element={<ZuweisungPage />} />
                  <Route path="/kalender" element={<KalenderPage />} />
                  <Route
                    path="/users"
                    element={
                      <AdminRoute>
                        <UsersPage />
                      </AdminRoute>
                    }
                  />
                </Routes>
              </Layout>
            </AppRoute>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <EnvironmentProvider>
          <AppContent />
          <OfflineIndicator />
        </EnvironmentProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
